function formatCategoryWorkflow(workflow) {
  if (workflow.categoryId) return workflow

  return {
    workflowId: workflow.id,
    categoryId: workflow.associationId,
    type: workflow.type,
    status: workflow.status,
    errorMessage: workflow.errorMessage
  }
}

export { formatCategoryWorkflow }
